import { Animation } from '@ionic/core';
import { DURATION_LONG_2, DURATION_SHORT_4, EASING_EMPHASIZED_DECCELERATE, growY } from '../../../../utils/animations';

export function accordionItemOpenAnimation(accordionItem: HTMLElement): Animation {
  // Leve gambiarra para pegar o tamanho total do Accordion Item
  accordionItem.style.display = 'block';
  const accordionItemHeight = accordionItem.offsetHeight;

  // Reset do valor original para o display
  accordionItem.style.display = '';

  // TODO[MLH014529]: Validar necessidade e valor do Treshold de tamanho do Accordion Item Content
  const accordionItemHeightTreshold = 750;
  const accordionItemOpen = (growY({ from: '0px', to: `${accordionItemHeight}px` }) as Animation)
    .addElement(accordionItem)
    .easing(EASING_EMPHASIZED_DECCELERATE);

  if (accordionItemHeight > accordionItemHeightTreshold) {
    accordionItemOpen.duration(DURATION_LONG_2);
  } else {
    accordionItemOpen.duration(DURATION_SHORT_4);
  }

  return accordionItemOpen;
}
